import { getHeaderMenuItems } from './Amalgam';
import { getCustomerOrderPortalRoute, shouldShowCustomerAccountMenu } from './customerOrders';
import { isDesktopView } from './Utils';
import { logoutVisitor, getVisitorPhoneVerified } from './Visitor';
import { isCurrentPlatformIOS } from '../../../../nativeConnectors/platform';
import EventBus from './EventBus';
import I18n from './I18n';

export const MENU_TYPE = {
  CATALOGUE_LINK: 'CATALOGUE',
  OTHER_PAGE_LINK: 'PAGE',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  CUSTOM_LINK: 'CUSTOM_LINK',
  SUB_MENU: 'SUB_MENU'
};

export const FOOTER_SECTION_TYPE = {
  CONTACT: 'contact',
  ADDRESS: 'address',
  PHONE: 'phone',
  EMAIL: 'email',
  SOCIAL_LINKS: 'social_links',
  MENU: 'menu',
  CUSTOM: 'custom'
};

export const getCustomerAccountSubMenu = (isMobileWebView = false) => ({
  id: 'my-account',
  title: I18n.t('MY_ACCOUNT') || 'My Account',
  useRoute: isDesktopView(),
  subMenuClassName: isDesktopView() && !isMobileWebView ? '' : 'my-account-links-sub-menu',
  linkType: MENU_TYPE.SUB_MENU,
  menuItems: [
    {
      id: 'my-order-history',
      title: I18n.t('ORDER_HISTORY') || 'Order History',
      useRoute: isDesktopView(),
      linkType: MENU_TYPE.OTHER_PAGE_LINK,
      linkPath: getCustomerOrderPortalRoute()
    },
    {
      id: 'logout-account-btn',
      title: I18n.t('LOGOUT') || 'Logout',
      linkType: MENU_TYPE.CUSTOM_LINK,
      shouldShow: () => getVisitorPhoneVerified(),
      onClick: logoutVisitor
    },
    {
      id: 'delete-account-btn',
      title: I18n.t('DELETE_ACCOUNT') || 'Delete Account',
      linkType: MENU_TYPE.CUSTOM_LINK,
      shouldShow: () => getVisitorPhoneVerified() && (isCurrentPlatformIOS() || isMobileWebView),
      onClick: () => EventBus.notify(EventBus.TYPE.CONFIRM_DELETE_ACCOUNT)
    }
  ]
});

export const getMenuData = (isMobileWebView = false) => {
  const isDesktop = isDesktopView();
  const LIMIT = 6;
  let data = getHeaderMenuItems();

  if (shouldShowCustomerAccountMenu() || isMobileWebView) {
    data = [getCustomerAccountSubMenu(isMobileWebView), ...data];
  }

  if (!Array.isArray(data)) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject('Not Found');
  }

  if (data.length <= LIMIT || (!isDesktop && !isMobileWebView)) {
    return Promise.resolve(data);
  }

  data = [
    ...data.slice(0, LIMIT),
    {
      id: 'qs-defined-more-menu',
      title: 'More',
      linkType: MENU_TYPE.SUB_MENU,
      linkPath: null,
      menuItems: data.slice(LIMIT)
    }
  ];

  return Promise.resolve(data);
};
